import Sparkline from "./Sparkline";

export default function KpiCard({
  label,
  value,
  icon: Icon,
  trend,
  trendLabel,
  comparison,
  sparkline,
  onClick,
  as: Tag = onClick ? "button" : "div",
  accent = "primary",
  children,
  className = "",
}) {
  const trendUp = trend != null && trend >= 0;
  return (
    <Tag
      type={Tag === "button" ? "button" : undefined}
      className={`kpi-card kpi-card--${accent} ${onClick ? "kpi-card--interactive" : ""} ${className}`}
      onClick={onClick}
    >
      <div className="kpi-card-header">
        <div className="kpi-card-main">
          <div className="kpi-card-value">{value}</div>
          <div className="kpi-card-label">{label}</div>
        </div>
        {Icon ? (
          <span className="kpi-card-icon" aria-hidden>
            <Icon size={22} strokeWidth={1.85} />
          </span>
        ) : null}
      </div>
      {(trend != null || comparison) && (
        <div className="kpi-card-meta">
          {trend != null && (
            <span className={`kpi-card-trend ${trendUp ? "up" : "down"}`}>
              {trendUp ? "↑" : "↓"} {Math.abs(trend).toFixed(1)}%
            </span>
          )}
          {comparison && <span className="kpi-card-comparison">{comparison}</span>}
          {trendLabel && <span className="kpi-card-trend-label">{trendLabel}</span>}
        </div>
      )}
      {sparkline?.length > 0 && (
        <div className="kpi-card-spark">
          <Sparkline values={sparkline} width={160} height={40} stroke="var(--chart-line)" fill="var(--chart-line)" />
        </div>
      )}
      {children}
    </Tag>
  );
}
